// Browser-safe formatting: retain decimal-string precision even above Number.MAX_SAFE_INTEGER.
export function formatCreditsText(value: string | null | undefined, unlimited = false): string {
  if (unlimited) return '不限量';
  if (value == null || value === '') return '—';
  if (!/^-?\d+(?:\.\d+)?$/.test(value)) return value;
  const negative = value.startsWith('-');
  const [whole, fraction = ''] = value.replace(/^-/, '').split('.');
  const micros = BigInt(whole) * 1000000n + BigInt(fraction.padEnd(6, '0').slice(0, 6));
  if (micros === 0n) return '0';
  if (micros < 10000n) return negative ? '-0.01 < 余额 < 0' : '<0.01';
  const cents = (micros + 5000n) / 10000n;
  const integer = (cents / 100n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const decimal = (cents % 100n).toString().padStart(2, '0').replace(/0+$/, '');
  return `${negative ? '-' : ''}${integer}${decimal ? `.${decimal}` : ''}`;
}

export function shanghaiTodayText(now = new Date()): string {
  return new Date(now.getTime() + 8 * 3600000).toISOString().slice(0, 10);
}

export function usagePageSize(value: string | null): number {
  const size = Number(value);
  return [20, 50, 100].includes(size) ? size : 20;
}

export const usagePagination = {
  showSizeChanger: true,
  pageSizeOptions: [20, 50, 100],
  showTotal: (total: number) => `共 ${total} 条`,
};
